export default __webpack_public_path__ + "static/media/baptism4.51de5d76.jpg";